// حالات الحجز وطرق الدفع — مشتركة بين لوحة المنشآت الكاملة ولوحة تسيار للملاعب
export const BOOKING_STATUS_META = {
  pending: { label: 'قيد المراجعة', badge: 'bg-amber-50 text-amber-700 border-amber-200', dot: 'bg-amber-500' },
  pending_payment: { label: 'بانتظار الدفع', badge: 'bg-orange-50 text-orange-700 border-orange-200', dot: 'bg-orange-500' },
  pending_payment_verification: { label: 'بانتظار التحقق من الدفع', badge: 'bg-blue-50 text-blue-700 border-blue-200', dot: 'bg-blue-500' },
  booked: { label: 'مؤكد', badge: 'bg-emerald-50 text-emerald-700 border-emerald-200', dot: 'bg-emerald-500' },
  rejected: { label: 'مرفوض', badge: 'bg-red-50 text-red-600 border-red-200', dot: 'bg-red-500' },
  cancelled: { label: 'ملغي', badge: 'bg-slate-100 text-slate-500 border-slate-200', dot: 'bg-slate-400' },
  blocked: { label: 'محظور', badge: 'bg-slate-100 text-slate-500 border-slate-200', dot: 'bg-slate-400' },
};

export const statusMeta = (status) => BOOKING_STATUS_META[status] || { label: status, badge: 'bg-slate-100 text-slate-500 border-slate-200', dot: 'bg-slate-400' };

export const PAYMENT_METHOD_META = {
  bank_transfer: { label: 'تحويل بنكي', icon: 'landmark', color: '#1D4E89', logo: null },
  stc_pay: { label: 'STC Pay', icon: 'wallet', color: '#4F008C', logo: '/payment-logos/stc-pay.svg' },
  barq: { label: 'برق', icon: 'bolt', color: '#C99A00', logo: '/payment-logos/barq.svg' },
  pay_on_site: { label: 'الدفع في الموقع', icon: 'field', color: '#0F766E', logo: null },
};

export const PAYMENT_METHOD_ORDER = ['pay_on_site', 'bank_transfer', 'stc_pay', 'barq'];
